module.exports = __webpack_public_path__ + "img/ico-pressure-edit-n.67e59e34.png";